/**
 * Knowledge Gaps API Service
 * Super Admin only - view and manage detected knowledge gaps
 */

import apiClient from './client';

export interface KnowledgeGap {
  id: string;
  reference: string;
  document_type: string;
  suggested_title: string;
  suggested_url: string;
  official_source: string;
  example_query: string;
  tenant_id: string;
  request_count: number;
  detected_at: string;
  last_seen_at: string;
  status: 'pending' | 'added' | 'ignored';
  admin_notes: string | null;
  resolved_at: string | null;
}

export async function listKnowledgeGaps(status?: string): Promise<KnowledgeGap[]> {
  const params = status && status !== 'all' ? { status } : {};
  const response = await apiClient.get<{ success: boolean; gaps: KnowledgeGap[] }>(
    '/admin/knowledge-gaps',
    { params }
  );
  return response.data.gaps;
}

export async function updateKnowledgeGap(
  id: string,
  data: { status: string; admin_notes?: string }
): Promise<KnowledgeGap> {
  const response = await apiClient.put<{ success: boolean; gap: KnowledgeGap }>(
    `/admin/knowledge-gaps/${id}`,
    data
  );
  return response.data.gap;
}

export async function deleteKnowledgeGap(id: string): Promise<void> {
  await apiClient.delete(`/admin/knowledge-gaps/${id}`);
}
